import { EventDispatcher } from "strongly-typed-events";

export class SideBarManager {

    constructor(private containerElement: JQuery) { }

    public initialize() {
        var self = this;
 
        self.containerElement.find('.toggle-btn').on('click', () => {
            self.containerElement.toggleClass('expand');
        });
    }
}